export default (props, vars) => props?.['student'].job_goals;
